/* ────────────────────────────────────────────────────────────────────
   Product card quick-add handler.
   Adds a single-variant product to cart and OPENS THE CART DRAWER
   (not navigating to /cart, which is redirected to / homepage).
   Dispatches events on window so cart-drawer.liquid (window listener)
   picks them up.
   ──────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  if (window.__dahabeyaProductCardInit) return;
  window.__dahabeyaProductCardInit = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.product-card__add-btn');
    if (!btn) return;
    if (btn.disabled || btn.classList.contains('btn--disabled')) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    event.preventDefault();

    var labelEl = btn.querySelector('[data-label]') || btn;
    var originalLabel = labelEl.textContent.trim();
    btn.disabled = true;
    labelEl.textContent = btn.getAttribute('data-loading-text') || '...';

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok || result.data.status) {
          throw new Error(result.data.description || result.data.message || 'cart_add_failed');
        }
        btn.dataset.success = 'true';
        labelEl.textContent = btn.getAttribute('data-added-text') || originalLabel;
        // Drawer listens on window — fire there.
        window.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: result.data } }));
        window.dispatchEvent(new CustomEvent('cart:open'));
        window.setTimeout(function () {
          delete btn.dataset.success;
          labelEl.textContent = originalLabel;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function (error) {
        console.error('Quick add failed:', error);
        labelEl.textContent = originalLabel;
        btn.disabled = false;
      });
  });
})();
